import React from 'react';
import { NavLink } from 'react-router-dom';

const AddClientTypeCrumb = () => <NavLink to="/admin/client-types/add">Add Client Type</NavLink>;

export default AddClientTypeCrumb;
